export const opacity = {
  opacity: {
    'see-through': '0.66',
  },
};
